common.View.create('canvas.blocks.custom.blogSlider.Block', {
    onDOMLoad() {
        this.initSwiper();
    },

    initSwiper() {
        let swiperEl = this.element.find('.blogSwiper');

        if (swiperEl.data('swiper-enabled') === false) {
            return;
        }

        new Swiper('.blogSwiper', {
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
            },
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                420: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                640: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                },
            },
            mousewheel: {
                releaseOnEdges: true,
                sensitivity: 1,
                invert: false,
            },
        });
    },
});
